import { useToggleCustomerRegistryForLocationV3, useSearchV3 } from '@ordr-as/ordr-service-types/epos';

export const useCustomerRegistryEnabled = (locationId: number) => {
  const { queryKey: _queryKey, ...result } = useToggleCustomerRegistryForLocationV3(locationId, {
    query: {
      enabled: !!locationId,
    },
  });
  return result;
};

export const useCustomerRegistry = (locationId: number, query: string | undefined) => {
  const { queryKey: _queryKey, ...result } = useSearchV3(
    locationId,
    { query },
    {
      query: {
        enabled: !!locationId,
      },
    }
  );
  return result;
};
